<template lang="pug">
SspLayout(area="activator")
  template(slot="actions")
    button.btn.btn-default(@click="$router.go(-1)") Back
  .row.activator
    .col-md-12
      .panel.panel-default
          .panel-heading
            h3.panel-title Calibrate Roll
          .panel-body
            img.img-responsive.calibrate-img(:src="calibrateImg")
            br
            p This step will determinate the direction of the roll. Once it is done it can NOT be changed.
            p The direction of the roll depends of the scanning order of first and second code.
            .alert.alert-danger(v-if="calibrateErrorMsg") {{calibrateErrorMsg}}
            form.form-horizontal(@submit.prevent="doCalibration()")
              .form-group
                .col-sm-6
                  p
                    label(for="first-code-input").control-label First Code
                    input#first-code-input.form-control(v-model="firstCode")
              .form-group
                .col-sm-6
                  p
                    label(for="second-code-input").control-label Second Code
                    input#second-code-input.form-control(v-model="secondCode")
              .form-group
                .col-sm-6.text-right
                  SspActionButton(type="submit" :disabled="!(firstCode && secondCode)" :spinning="calibrating" text="Calibrate" style="margin-top:5px")
</template>
<script>
import miniToastr from 'mini-toastr'
import Util from '@/service/Util'
import activationSession from './service/ActivationSession'

export default {
  mounted() {
    this.$el.querySelector('#first-code-input').focus()
  },
  data: () => ({
    calibrating: false,
    calibrateImg: require('../../../assets/images/roll.png'),
    calibrateErrorMsg: null,
    firstCode: '',
    secondCode: ''
  }),
  methods: {
    doCalibration() {
      this.calibrating = true
      const firstCode = Util.removeUrl(this.firstCode)
      const secondCode = Util.removeUrl(this.secondCode)
      activationSession
        .calibrate(firstCode, secondCode)
        .then(() => {
          this.$router.push({
            name: 'activator-home',
            query: {
              code: activationSession.getCode(),
              channel: activationSession.getCfgId()
            }
          })
          miniToastr.success('Roll successfully calibrated')
        })
        .catch((e) => {
          this.calibrateErrorMsg = e.response.data.message
        })
        .then(() => {
          this.calibrating = false
        })
    }
  }
}
</script>
<style lang="scss">
.activator {
  .calibrate-img {
    margin: 5px 0;
  }

  @media (min-width: 992px) {
    .calibrate-img {
        float: right;
        margin: 7px 10px 0 7px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/activator/Calibration.vue